import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './SettingsPage.css';
import AdUnit from './AdUnit';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const AdSensePlaceholder = ({ position }) => (
  <div className="adsense-placeholder">
    <div className="ad-content">
      <span className="ad-label"></span>
      <p className="ad-text">{/*AdSense Ad #position*/}
        <AdUnit adSlot="1700647405" /> {/* Use your actual ad slot ID */}
      </p>
    </div>
  </div>
);

const SettingsPage = ({ user, token, onUpdate, onUpgradeClick }) => {
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [ethnicity, setEthnicity] = useState('');
  const [gender, setGender] = useState('');
  const [location, setLocation] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const navigate = useNavigate();

  const isFree = user.tier === 'free';

  useEffect(() => {
    if (user.profile) {
      setDateOfBirth(user.profile.dateOfBirth || '');
      setEthnicity(user.profile.ethnicity || '');
      setGender(user.profile.gender || '');
      setLocation(user.profile.location || '');
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/user/settings`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          dateOfBirth,
          ethnicity,
          gender,
          location
        })
      });

      if (response.ok) {
        setMessage('Settings saved successfully! ✨');
        onUpdate();
        setTimeout(() => setMessage(''), 3000);
      } else {
        const data = await response.json();
        setError(data.error || 'Failed to save settings');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settings-page">
      <div className="cosmic-bg"></div>
      
      <div className="page-header">
        <h1 className="page-title"> Settings</h1>
        <p className="page-subtitle">Personalize your experience for more accurate predictions</p>
      </div>

      <div className="settings-content">
        <div className="settings-main">
          <div className="card settings-card">
            <div className="card-header">
              <h2 className="card-title">
                <span className="title-icon">👤</span>
                Personal Information
              </h2>
              <p className="card-subtitle">All fields marked with * are mandataory for Comprehensive analysis</p>
            </div>

            <form onSubmit={handleSubmit} className="settings-form">
              <div className="form-row">
                <div className="input-group">
  <label className="input-label">
    <span className="label-icon">📆</span>
    Date of Event *
  </label>
  <div style={{ display: 'flex', gap: '10px' }}>
    <select
      className="event-input"
      value={dateOfBirth.split('-')[0] || ''}
      onChange={(e) => {
        const year = e.target.value;
        const month = dateOfBirth.split('-')[1] || '01';
        const day = dateOfBirth.split('-')[2] || '01';
        setDateOfBirth(`${year}-${month}-${day}`);
      }}
      required
      style={{ flex: 1 }}
    >
      <option value="">Year</option>
      {Array.from({ length: 2025 - 1960 + 1 }, (_, i) => 2025 - 18 - i).map(year => (
        <option key={year} value={year}>{year}</option>
      ))}
    </select>

    <select
      className="event-input"
      value={dateOfBirth.split('-')[1] || ''}
      onChange={(e) => {
        const month = e.target.value.padStart(2, '0');
        const year = dateOfBirth.split('-')[0] || new Date().getFullYear();
        const day = dateOfBirth.split('-')[2] || '01';
        setDateOfBirth(`${year}-${month}-${day}`);
      }}
      required
      style={{ flex: 1 }}
    >
      <option value="">Month</option>
      {Array.from({ length: 12 }, (_, i) => i + 1).map(month => (
        <option key={month} value={month.toString().padStart(2, '0')}>
          {month}
        </option>
      ))}
    </select>

    <select
      className="event-input"
      value={dateOfBirth.split('-')[2] || ''}
      onChange={(e) => {
        const day = e.target.value.padStart(2, '0');
        const year = dateOfBirth.split('-')[0] || new Date().getFullYear();
        const month = dateOfBirth.split('-')[1] || '01';
        setDateOfBirth(`${year}-${month}-${day}`);
      }}
      required
      style={{ flex: 1 }}
    >
      <option value="">Day</option>
      {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
        <option key={day} value={day.toString().padStart(2, '0')}>
          {day}
        </option>
      ))}
    </select>
  </div>
</div>
                {/*<div className="input-group">
                  <label className="input-label">
                    <span className="label-icon">🎂</span>
                    Date of Birth*
                  </label>
                  <input
                    type="date"
                    className="settings-input"
                    value={dateOfBirth}
                    onChange={(e) => setDateOfBirth(e.target.value)}
                  />
                  <span className="input-hint">Used for habbitual trends</span>
                </div> */}
                

                <div className="input-group">
                  <label className="input-label">
                    <span className="label-icon">⚧️</span>
                    Gender*
                  </label>
                  <select
                    className="settings-select"
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                  >
                    <option value="">Prefer not to say</option>
                    <option value="female">Female</option>
                    <option value="male">Male</option>
                    
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="input-group">
                  <label className="input-label">
                    <span className="label-icon">🌍</span>
                    Ethnicity*
                  </label>
                  <select
                    
                    className="settings-select"
                    value={ethnicity}
                    onChange={(e) => setEthnicity(e.target.value)}
                    
                  >
                    <option value="globetrotter">I belong to the world</option>
                    <option value="white caucasian">White Caucasian</option>
                    <option value="American">White American</option>
                    <option value="African American">African American</option>
                    <option value="Hispanic">Hispanic</option>
                    <option value="European">European</option>
                    <option value="African">African</option>
                    <option value="Middle-Eastern">Middle-Eastern</option>
                    <option value="Central-Asian">Central-Asian</option>
                    <option value="Indian">Indian Subcontinent</option>
                    <option value="Southeast Asian">South East Asian</option>
                    <option value="East Asian">East Asian/pacific</option>
                    
                  </select>
                  <span className="input-hint">Your sense of belonging</span>
                </div>

                <div className="input-group">
                  <label className="input-label">
                    <span className="label-icon">📍</span>
                    Location*
                  </label>
                  <select
                    className="settings-select"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                  >
                    <option value="North America">North America</option>
                    <option value="Latin America">Latin America</option>
                    <option value="Europe">Europe</option>
                    <option value="Africa">Africa</option>
                    <option value="Asia">Asia</option>
                    <option value="Australia">Australia</option>
                  </select>
                  <span className="input-hint">Used for general regional insights</span>
                </div>
              </div>

              {message && (
                <div className="success-message">
                  <span className="success-icon">✓</span>
                  {message}
                </div>
              )}

              {error && (
                <div className="error-message">
                  <span className="error-icon">⚠️</span>
                  {error}
                </div>
              )}

              <button 
                type="submit" 
                className="save-btn"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-small"></span>
                    <span>Saving...</span>
                  </>
                ) : (
                  <>
                    <span className="btn-icon">💾</span>
                    <span>Save Changes</span>
                  </>
                )}
              </button>
            </form>
          </div>

          {/* Account Info */}
          <div className="card account-card">
            <h2 className="card-title">
              <span className="title-icon">📊</span>
              Account Details
            </h2>
            
            <div className="account-info">
              <div className="info-item">
                <span className="info-label">Email:</span>
                <span className="info-value">{user.email}</span>
              </div>
              
              <div className="info-item">
                <span className="info-label">Current Plan:</span>
                <span className={`tier-badge tier-${user.tier}`}>
                  {user.tier.toUpperCase()}
                </span>
              </div>
              
              <div className="info-item">
                <span className="info-label">Member Since:</span>
                <span className="info-value">
                  {new Date(user.createdAt).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </span>
              </div>
            </div>

            {user.tier === 'free' && !onUpgradeClick (
              <div className="upgrade-prompt">
                <p>✨ Unlock more features with a paid or premium plan!</p>
                <div>
                  {/* Current plan display */}
                  <div className="plan-section">
                    <h3>Current Plan: Free</h3>
                    <button onClick={() => navigate('/upgrade')}>
                      View All Plans
                    </button>
                  </div>
                </div>
              
              </div>
              
            )}

            {/* Disclaimer Link */}
            <div className="disclaimer-link-container">
              <Link to="/disclaimer" className="disclaimer-link">
                <span className="disclaimer-icon">⚠️</span>
                <span>View AI Usage & Disclaimer</span>
              </Link>
            </div>
          </div>
        </div>
          {/* AdSense Sidebar for Free Tier - mrn */}
          {isFree && (
            <div className="modal-sidebar">
              <AdSensePlaceholder />{/* Place the AdUnit component here */}
              
            </div>
          )}
        
      </div>
    </div>
  );
};

export default SettingsPage;